import React from "react";
import {
  Accordion,
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleNotch,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";

import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import MarkDownViewer from "../../../../components/markdownViewer/MarkDownViewer";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import { InputGroup, Table } from "react-bootstrap";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import equals from "fast-deep-equal";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";
import BaseDatePicker from "../../../../components/baseDatePicker/BaseDatePicker";
import AuditorsAsyncTypeAhead from "../../AuditorsTypeahead/AuditorsTypeahead";

import SecurityLevel from "../../../../helpers/SecurityLevel";

import "./CreateExaminationDialog.css";
import Switch from "react-switch";
import ConfigurationTab from "../../../singleExamination/tabs/configurationTab/ConfigurationTab";

class CreateExaminationDialog extends React.Component {
  constructor(props) {
    super(props);

    this.securityOptions = SecurityLevel.getSecurityLevels();

    this.autoOptions = [
      { value: false, label: "Examinations.CreateExamModal.Form.Disable" },
      { value: true, label: "Examinations.CreateExamModal.Form.Enable" },
    ];
    this.authenticatedUser = CamplaCoreService.getAuthenticatedUser();
    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isExaminationName,
      },
      moduleClasses: {
        defaultValue: this.props.cloneExamination
          ? [this.props.cloneExamination.moduleClassId]
          : [],
        rule: ValidationHelper.isIDArray,
      },
      instanceTemplateId: {
        defaultValue: this.props.selectedInstanceTemplate || "",
        initValid: this.props.selectedInstanceTemplate !== undefined,
        rule: ValidationHelper.isID,
      },
      networkProfileId: {
        defaultValue: this.props.cloneExamination
          ? this.props.cloneExamination.networkProfileId
          : "",
        initValid: this.props.selectedInstanceTemplate !== undefined,
        rule: ValidationHelper.isID,
      },
      start: {
        defaultValue: this.props.cloneExamination
          ? new Date(Date.parse(this.props.cloneExamination.start))
          : "",
        initValid: this.props.cloneExamination
          ? ValidationHelper.isStartDate(
              this.props.cloneExamination.start,
              this.state.validation.end.value,
            )
          : false,
        rule: (value) =>
          ValidationHelper.isStartDate(value, this.state.validation.end.value),
      },
      end: {
        defaultValue: this.props.cloneExamination
          ? new Date(Date.parse(this.props.cloneExamination.end))
          : "",
        initValid: this.props.cloneExamination
          ? ValidationHelper.isEndDate(
              this.props.cloneExamination.end,
              this.state.validation.start.value,
            )
          : false,
        rule: (value) =>
          ValidationHelper.isEndDate(value, this.state.validation.start.value),
      },
      securityLevel: {
        defaultValue: this.props.cloneExamination
          ? this.props.cloneExamination.securityLevel
          : 1,
        initValid: true,
        rule: ValidationHelper.isSecurityLevel,
      },
      isAutoStart: {
        defaultValue: this.props.cloneExamination
          ? this.props.cloneExamination.isAutoStart
          : false,
        initValid: true,
        rule: ValidationHelper.isBoolean,
      },
      isAutoEnd: {
        defaultValue: this.props.cloneExamination
          ? this.props.cloneExamination.isAutoEnd
          : false,
        initValid: true,
        rule: ValidationHelper.isBoolean,
      },
      auditors: {
        defaultValue: this.props.cloneExamination
          ? this.props.cloneExamination.auditors
          : [],
        initValid: true,
        rule: ValidationHelper.isObjectArray,
      },
      instructions: {
        defaultValue: this.props.cloneExamination
          ? this.props.cloneExamination.instructions
          : ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isExtendedDescription,
      },
      configuration: {
        defaultValue: null,
        initValid: false,
        rule: ValidationHelper.isObject,
      },
      owner: {
        defaultValue: this.authenticatedUser || null,
        initValid: true,
        rule: ValidationHelper.isObject,
      },
      cloneStudentFiles: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean,
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      selectedNetworkProfile: null,
      selectedInstanceTemplate: null,
      possibleAuditorsList: [],
      auditors: [],
      clear: false,
      newMemberEmail: "",
      newMemberUserId: "",
      newMemberValid: false,
      examination: null,
      isRunning: false
    };

    this.configurationCache = new Map();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.updateExamination = this.updateExamination.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
    this.handleInstanceTemplateChange = this.handleInstanceTemplateChange.bind(
      this,
    );
    this.handleUpdateConfiguration = this.handleUpdateConfiguration.bind(this);
    this.loadExaminationConfiguration = this.loadExaminationConfiguration.bind(
      this,
    );
    this.handleAddMember = this.handleAddMember.bind(this);
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.getAuditors = this.getAuditors.bind(this);
    this.handleCheckEmail = this.handleCheckEmail.bind(this);
  }

  async loadExaminationConfiguration() {
    try {
      const securityLevelTemplateIdKey = `${this.props.selectedInstanceTemplate._id}-${this.state.validation.securityLevel.value}`;
      let configuration;
      if (this.props.cloneExamination) {
        const examination = await CamplaCoreService.getExamination(
          this.props.cloneExamination._id,
        );
        configuration = examination.configuration;
      } else {
        if (this.props.selectedInstanceTemplate) {
          configuration = await CamplaCoreService.getExaminationConfiguration(
            this.props.selectedInstanceTemplate.preferredNetworkProfile,
            this.props.selectedInstanceTemplate._id,
          );
        }
      }
      this.configurationCache.set(securityLevelTemplateIdKey, configuration);
      this.setState({
        examination: {
          _id: this.props.cloneExamination
            ? this.props.cloneExamination._id
            : null,
          status: 50,
          securityLevel: this.state.validation.securityLevel.value,
          configuration,
          instanceTemplate: this.props.selectedInstanceTemplate,
        },
      });
      this.handleChange({
        target: {
          name: "configuration",
          value: configuration,
        },
      });
    } catch (err) {
      console.log(err);
    }
  }

  handleUpdateConfiguration(configuration) {
    const securityLevelTemplateIdKey = `${this.state.selectedInstanceTemplate._id}-${this.state.validation.securityLevel.value}`;
    this.configurationCache.set(securityLevelTemplateIdKey, configuration);
    this.handleChange({
      target: {
        name: "configuration",
        value: configuration,
      },
    });
  }

  async updateExamination(instanceTemplate, networkProfile) {
    if (
      (this.state.examination
          && this.state.examination.instanceTemplate._id === instanceTemplate._id
          && this.state.examination.securityLevel === this.state.validation.securityLevel.value)
        || this.state.examination === null
    ) {
      return;
    }


    const securityLevelTemplateIdKey = `${instanceTemplate._id}-${this.state.validation.securityLevel.value}`;
    let configuration;
    try {
      if (this.configurationCache.has(securityLevelTemplateIdKey)) {
        configuration = this.configurationCache.get(securityLevelTemplateIdKey);
      } else {
        configuration = await CamplaCoreService.getExaminationConfiguration(
          networkProfile._id,
          instanceTemplate._id,
        );
      }

      // Sync configuration
      if (this.state.examination.instanceTemplate._id === instanceTemplate._id){
        Object.keys(this.state.validation.configuration.value)
            .filter(k => typeof configuration[k] !== "undefined")
            .forEach(k => configuration[k] = this.state.validation.configuration.value[k]);
      }

      this.configurationCache.set(securityLevelTemplateIdKey, configuration);
      this.setState({
        examination: {
          _id: this.props.cloneExamination
            ? this.props.cloneExamination._id
            : null,
          status: 50,
          securityLevel: this.state.validation.securityLevel.value,
          configuration,
          instanceTemplate: instanceTemplate,
        },
      });
      this.handleChange({
        target: {
          name: "configuration",
          value: configuration,
        },
      });
    } catch (err) {
      console.log(err);
    }
  }

  translateOptions(t, options) {
    if (Array.isArray(options)) {
      return options.map((o) => {
        return { value: o.value, label: t(o.label) };
      });
    } else {
      return { value: options.value, label: t(options.label) };
    }
  }

  handleChange(event) {
    this.setState(
      {
        validation: ValidationHelper.update(event, this.state.validation),
      },
      async () => {
        await this.updateExamination(
          this.state.selectedInstanceTemplate,
          this.state.selectedNetworkProfile
        );
      },
    );
  }

  handleInstanceTemplateChange(instanceTemplate) {
    this.setState(
      {
        selectedInstanceTemplate: instanceTemplate,
        selectedNetworkProfile: this.props.networkProfiles.find(
          (n) => n._id === instanceTemplate.preferredNetworkProfile,
        ),
      },
      () => {
        this.handleChange({
          target: {
            name: "instanceTemplateId",
            value: instanceTemplate._id,
          },
        });
        this.handleChange({
          target: {
            name: "networkProfileId",
            value: instanceTemplate.preferredNetworkProfile,
          },
        });
      },
    );
  }

  async getAuditors(aud) {
    if (typeof aud === "string" && aud.length > 2) {
      const possibleAuditorsList = await CamplaCoreService.getAllAuditors(aud);
      this.setState({ possibleAuditorsList });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.show !== this.props.show) {
      let hasInstanceTemplate = false;
      let selectedNetworkProfile = null;
      if (this.props.selectedInstanceTemplate !== null) {
        hasInstanceTemplate = true;
        selectedNetworkProfile = this.props.selectedInstanceTemplate
          .preferredNetworkProfile
          ? this.props.networkProfiles.find(
              (n) =>
                n._id ===
                this.props.selectedInstanceTemplate.preferredNetworkProfile,
            )
          : null;
      }

      this.configurationCache.clear();
      this.authenticatedUser = CamplaCoreService.getAuthenticatedUser();
      const validation = ValidationHelper.getValidation({
        name: {
          defaultValue: "",
          rule: ValidationHelper.isExaminationName,
        },
        moduleClasses: {
          defaultValue: this.props.cloneExamination
            ? [this.props.cloneExamination.moduleClassId]
            : [],
          initValid: this.props.cloneExamination ? true : false,
          rule: ValidationHelper.isIDArray,
        },
        instanceTemplateId: {
          defaultValue: hasInstanceTemplate
            ? this.props.selectedInstanceTemplate._id
            : "",
          initValid: hasInstanceTemplate,
          rule: ValidationHelper.isID,
        },
        networkProfileId: {
          defaultValue: this.props.cloneExamination
            ? this.props.cloneExamination.networkProfileId
            : selectedNetworkProfile
            ? selectedNetworkProfile._id
            : "",
          initValid: selectedNetworkProfile !== null,
          rule: ValidationHelper.isID,
        },
        start: {
          defaultValue: this.props.cloneExamination
            ? new Date(Date.parse(this.props.cloneExamination.start))
            : "",
          initValid: this.props.cloneExamination
            ? ValidationHelper.isStartDate(
                this.props.cloneExamination.start,
                this.props.cloneExamination.end,
              )
            : false,
          rule: (value) =>
            ValidationHelper.isStartDate(
              value,
              this.state.validation.end.value,
            ),
        },
        end: {
          defaultValue: this.props.cloneExamination
            ? new Date(Date.parse(this.props.cloneExamination.end))
            : "",
          initValid: this.props.cloneExamination
            ? ValidationHelper.isEndDate(
                this.props.cloneExamination.end,
                this.props.cloneExamination.start,
              )
            : false,
          rule: (value) =>
            ValidationHelper.isEndDate(
              value,
              this.state.validation.start.value,
            ),
        },
        securityLevel: {
          defaultValue: this.props.cloneExamination
            ? this.props.cloneExamination.securityLevel
            : 1,
          initValid: true,
          rule: ValidationHelper.isSecurityLevel,
        },
        isAutoStart: {
          defaultValue: this.props.cloneExamination
            ? this.props.cloneExamination.isAutoStart
            : false,
          initValid: true,
          rule: ValidationHelper.isBoolean,
        },
        isAutoEnd: {
          defaultValue: this.props.cloneExamination
            ? this.props.cloneExamination.isAutoEnd
            : false,
          initValid: true,
          rule: ValidationHelper.isBoolean,
        },
        auditors: {
          defaultValue: this.props.cloneExamination
            ? this.props.cloneExamination.auditors
            : [],
          initValid: true,
          rule: ValidationHelper.isObjectArray,
        },
        instructions: {
          defaultValue: this.props.cloneExamination
            ? this.props.cloneExamination.instructions
            : ValidationHelper.getDefaultValueExtendedDescription(),
          initValid: true,
          rule: ValidationHelper.isExtendedDescription,
        },
        configuration: {
          defaultValue: null,
          initValid: false,
          rule: ValidationHelper.isObject,
        },
        owner: {
          defaultValue: this.props.cloneExamination ? (
              this.props.users.find(u => u._id === this.props.cloneExamination.userId)
          ) : (this.authenticatedUser || null),
          initValid: true,
          rule: ValidationHelper.isObject,
        },
        cloneStudentFiles: {
          defaultValue: false,
          initValid: true,
          rule: ValidationHelper.isBoolean,
        },
      });
      this.setState(
        {
          selectedInstanceTemplate: this.props.selectedInstanceTemplate,
          selectedNetworkProfile: selectedNetworkProfile,
          validation: validation,
          possibleAuditorsList: [],
          auditors: [],
          newMemberEmail: "",
          newMemberUserId: "",
          newMemberValid: false,
        },
        () => {
          if (
            !equals(
              prevProps.selectedInstanceTemplate,
              this.props.selectedInstanceTemplate,
            )
          ) {
            this.handleInstanceTemplateChange(
              this.props.selectedInstanceTemplate,
            );
          }
          this.loadExaminationConfiguration();
        },
      );
    } else {
      if (
        !equals(
          prevProps.selectedInstanceTemplate,
          this.props.selectedInstanceTemplate,
        )
      ) {
        this.handleInstanceTemplateChange(this.props.selectedInstanceTemplate);
      }
    }
  }

  handleHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  handleAddMember() {
    if (
      this.state.newMemberValid &&
      this.state.newMemberUserId.length > 0 &&
      !this.state.validation.auditors.value.some(
        (a) => a.email === this.state.newMemberEmail,
      )
    ) {
      const updatedMembers = [
        {
          _id: this.state.newMemberUserId,
          email: this.state.newMemberEmail,
        },
        ...this.state.validation.auditors.value,
      ];
      this.setState({
        validation: ValidationHelper.update(
          {
            target: {
              name: "auditors",
              value: updatedMembers,
            },
          },
          this.state.validation,
        ),
      });
      this.setState({ newMemberEmail: "", clear: true });
    }
  }

  handleRemoveMember(member) {
    const updatedMembers = this.state.validation.auditors.value.filter(
      (aud) => aud._id !== member._id,
    );
    this.setState({
      validation: ValidationHelper.update(
        {
          target: {
            name: "auditors",
            value: updatedMembers,
          },
        },
        this.state.validation,
      ),
    });
  }

  async handleCheckEmail(email) {
    if (ValidationHelper.isEmail(email)) {
      try {
        const foundMembers = this.state.possibleAuditorsList.filter(
          (user) => user.email === email,
        );
        if (foundMembers.length > 0) {
          this.setState({
            newMemberValid: true,
            newMemberEmail: foundMembers[0].email,
            newMemberUserId: foundMembers[0]._id,
          });
          return;
        }
      } catch (err) {}
    }
    this.setState({ newMemberValid: false });
  }

  async handleSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      this.setState({isRunning: true});
      await this.props.onSubmit(validatedData, this.props.cloneExamination);
      this.setState({isRunning: false});
    }
  }

  render() {
    const isInvalid = !ValidationHelper.isIDArray(
      this.state.validation.moduleClasses.value,
    );

    const { t } = this.props;
    const instructions = this.props.cloneExamination
      ? this.props.cloneExamination.instructions
      : ValidationHelper.getDefaultValueExtendedDescription();
    const showPreferredNetworkProfileAlert =
      this.state.selectedInstanceTemplate &&
      this.state.selectedInstanceTemplate.preferredNetworkProfile &&
      this.state.selectedNetworkProfile &&
      this.state.selectedNetworkProfile._id !==
        this.state.selectedInstanceTemplate.preferredNetworkProfile;
    this.securityOptions = SecurityLevel.getSecurityLevels(
      this.state.selectedInstanceTemplate
        ? this.state.selectedInstanceTemplate.type
        : undefined,
    );
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.handleHide}
        rightButtonCallback={this.handleSubmit}
        title={t("Examinations.CreateExamModal.Title")}
        rightButtonText={
          this.props.cloneExamination
            ? t("Examinations.CreateExamModal.Form.Clone")
            : t("Examinations.CreateExamModal.Form.Submit")
        }
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.handleHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonIsLoading={this.state.isRunning}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form onSubmit={this.handleSubmit}>
            <Accordion defaultActiveKey="0">
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="0"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.name.isValid &&
                        this.state.validation.moduleClasses.isValid &&
                        this.state.validation.securityLevel.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t("Examinations.CreateExamModal.Form.ToggleBasic")}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    {this.props.cloneExamination &&
                    CamplaCoreService.getAuthenticatedUser() &&
                    CamplaCoreService.getAuthenticatedUser().role === 1 &&
                    (this.props.cloneExamination.status === 1 ||
                      (this.props.cloneExamination.status >= 50 &&
                        this.props.cloneExamination.status <= 53)) ? (
                      <Form.Group controlId="formCloneStudentFiles">
                        <Form.Label>
                          {t(
                            "Examinations.CreateExamModal.Form.CloneStudentFiles",
                          )}{" "}
                        </Form.Label>
                        <Switch
                          className="float-right"
                          onColor="#54BF8D"
                          checked={
                            this.state.validation.cloneStudentFiles.value
                          }
                          onChange={(state) => {
                            this.handleChange({
                              target: {
                                name: "cloneStudentFiles",
                                value: state,
                              },
                            });
                          }}
                          height={18}
                          width={40}
                        />
                        <Form.Control
                          type="hidden"
                          isInvalid={
                            !this.state.validation.cloneStudentFiles.isValid
                          }
                        />
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {this.authenticatedUser
                        && this.authenticatedUser.role === 1
                        && Array.isArray(this.props.users)
                        && this.props.users.length > 0 ? (
                      <Form.Group controlId="formSelectOwner">
                        <Form.Label>
                          {t("Examinations.CreateExamModal.Form.Owner")}
                        </Form.Label>
                        <BaseSelect
                          isInvalid={!this.state.validation.owner.isValid}
                          options={this.props.users}
                          isMulti={false}
                          onChange={(s) => {
                            this.handleChange({
                              target: {
                                name: "owner",
                                value: s,
                              },
                            });
                          }}
                          defaultValue={
                            this.props.cloneExamination ? (
                                this.props.users.find((n) => n._id === this.props.cloneExamination.userId)
                            ) : (
                                this.authenticatedUser
                                    ? this.props.users.find(
                                        (n) => n._id === this.authenticatedUser._id,
                                    )
                                    : this.props.users[0]
                            )
                          }
                          getOptionLabel={(option) => option.email}
                          getOptionValue={(option) => option}
                        />
                        <Form.Control
                          type="hidden"
                          isInvalid={!this.state.validation.owner.isValid}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t(
                            "Examinations.CreateExamModal.ValidationError.Owner",
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    <Form.Group controlId="formClassName">
                      <Form.Label>
                        {t("Examinations.CreateExamModal.Form.ExamName")}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder={t(
                          "Examinations.CreateExamModal.Form.ExamNamePlaceholder",
                        )}
                        value={this.state.validation.name.value}
                        isInvalid={!this.state.validation.name.isValid}
                        onChange={this.handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t("Examinations.CreateExamModal.ValidationError.Name")}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectModuleClass">
                      <Form.Label>
                        {t("Examinations.CreateExamModal.Form.ModuleClass")}
                      </Form.Label>
                      <BaseSelect
                        isInvalid={!this.state.validation.moduleClasses.isValid}
                        options={this.props.moduleClasses}
                        placeholder={t(
                          "Examinations.CreateExamModal.Form.ModuleClassPlaceholder",
                        )}
                        isMulti={true}
                        onChange={(s) => {
                          this.handleChange({
                            target: {
                              name: "moduleClasses",
                              value: s ? s.map((i) => i._id) : [],
                            },
                          });
                        }}
                        defaultValue={
                          this.props.cloneExamination
                            ? this.props.moduleClasses.find(
                                (n) =>
                                  n._id ===
                                  this.props.cloneExamination.moduleClassId,
                              )
                            : []
                        }
                        getOptionLabel={(option) =>
                          `${option.className} - ${option.moduleName}`
                        }
                        getOptionValue={(option) => option._id}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.moduleClasses.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "Examinations.CreateExamModal.ValidationError.ModuleClasses",
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectSecurity">
                      <Form.Label>
                        {t("Examinations.CreateExamModal.Form.Security")}
                      </Form.Label>
                      <BaseSelect
                        options={this.translateOptions(t, this.securityOptions)}
                        onChange={(s) =>
                          this.handleChange({
                            target: {
                              name: "securityLevel",
                              value: s.value,
                            },
                          })
                        }
                        value={this.translateOptions(
                          t,
                          this.securityOptions.filter(
                            (s) =>
                              s.value ===
                              this.state.validation.securityLevel.value,
                          )[0],
                        )}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.securityLevel.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "Examinations.CreateExamModal.ValidationError.SecurityLevel",
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group controlId="formDateStart">
                          <Form.Label>
                            {t("Examinations.CreateExamModal.Form.StartTime")}
                          </Form.Label>
                          <div>
                            <BaseDatePicker
                              name="start"
                              className="form-control"
                              onChange={(d) => {
                                this.handleChange({
                                  target: { name: "start", value: d },
                                });
                                this.handleChange({
                                  target: {
                                    name: "end",
                                    value: this.state.validation.end.value,
                                  },
                                });
                              }}
                              value={this.state.validation.start.value}
                              min={new Date()}
                            />
                          </div>
                          <Form.Control
                            type="hidden"
                            isInvalid={!this.state.validation.start.isValid}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(
                              "Examinations.CreateExamModal.ValidationError.Start",
                            )}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="formSelectAutoStart">
                          <Form.Label>
                            {t("Examinations.CreateExamModal.Form.AutoStart")}
                          </Form.Label>
                          <BaseSelect
                            options={this.translateOptions(t, this.autoOptions)}
                            onChange={(s) =>
                              this.handleChange({
                                target: {
                                  name: "isAutoStart",
                                  value: s.value,
                                },
                              })
                            }
                            value={this.translateOptions(
                              t,
                              this.autoOptions.filter(
                                (s) =>
                                  s.value ===
                                  this.state.validation.isAutoStart.value,
                              )[0],
                            )}
                          />
                          <Form.Control
                            type="hidden"
                            isInvalid={
                              !this.state.validation.isAutoStart.isValid
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(
                              "Examinations.CreateExamModal.ValidationError.IsAutoStart",
                            )}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="formDateEnd">
                          <Form.Label>
                            {t("Examinations.CreateExamModal.Form.EndTime")}
                          </Form.Label>
                          <div>
                            <BaseDatePicker
                              name="end"
                              className="form-control"
                              onChange={(d) => {
                                this.handleChange({
                                  target: { name: "end", value: d },
                                });
                                this.handleChange({
                                  target: {
                                    name: "start",
                                    value: this.state.validation.start.value,
                                  },
                                });
                              }}
                              value={this.state.validation.end.value}
                              min={new Date()}
                            />
                          </div>
                          <Form.Control
                            type="hidden"
                            isInvalid={!this.state.validation.end.isValid}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(
                              "Examinations.CreateExamModal.ValidationError.End",
                            )}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="formSelectAutoStart">
                          <Form.Label>
                            {t("Examinations.CreateExamModal.Form.AutoEnd")}
                          </Form.Label>
                          <BaseSelect
                            options={this.translateOptions(t, this.autoOptions)}
                            onChange={(s) =>
                              this.handleChange({
                                target: {
                                  name: "isAutoEnd",
                                  value: s.value,
                                },
                              })
                            }
                            value={this.translateOptions(
                              t,
                              this.autoOptions.filter(
                                (s) =>
                                  s.value ===
                                  this.state.validation.isAutoEnd.value,
                              )[0],
                            )}
                          />
                          <Form.Control
                            type="hidden"
                            isInvalid={!this.state.validation.isAutoEnd.isValid}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(
                              "Examinations.CreateExamModal.ValidationError.IsAutoEnd",
                            )}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                  <Accordion.Toggle
                      as={Button}
                      variant="link"
                      className="acc-link"
                      eventKey="5"
                  >
                    <FontAwesomeIcon
                        icon={faExclamationCircle}
                        className={
                          this.state.validation.instructions.isValid
                              ? "display-none"
                              : "mr-2 color-red"
                        }
                    />
                    <span>
                      {t("Examinations.CreateExamModal.Form.Configuration")}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="5">
                  <Card.Body>
                    {this.state.selectedInstanceTemplate &&
                    this.state.examination ? (
                        <ConfigurationTab
                            onUpdateConfiguration={this.handleUpdateConfiguration}
                            onFetchData={() => {}}
                            examination={this.state.examination}
                            isUpdating={false}
                            instanceTemplateConfig={
                              this.state.selectedInstanceTemplate.configuration
                            }
                        />
                    ) : (
                        <FontAwesomeIcon icon={faCircleNotch} spin />
                    )}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="4"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.instanceTemplateId.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t(
                          "Examinations.CreateExamModal.Form.ToggleAuditors",
                      )}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <span>
                      {t(
                          "Examinations.CreateExamModal.Form.AuditorDescription",
                      )}
                    </span>
                    <InputGroup className="mt-4">
                      <Col className="p-0">
                        <AuditorsAsyncTypeAhead
                          moduleClasses={this.props.moduleClasses}
                          validation={this.state.validation}
                          onInputChange={this.getAuditors}
                          users={this.state.possibleAuditorsList}
                          handleAddMember={this.handleAddMember}
                          valid={this.state.newMemberValid}
                          emptyLabel={t(
                            "Groups.GroupModal.CreateModal.emptyLabel",
                          )}
                          promptText={t(
                            "Groups.GroupModal.CreateModal.promptText",
                          )}
                          placeholder={t(
                            "Groups.GroupModal.CreateModal.placeholder",
                          )}
                          onSelected={(selected) => {
                            this.setState({
                              newMemberEmail: selected[0],
                            });
                            this.handleCheckEmail(selected[0]);
                          }}
                          clear={this.state.clear}
                          onClear={() =>
                            this.setState({
                              clear: false,
                              newMemberEmail: "",
                              newMemberUserId: "",
                              newMemberValid: false,
                            })
                          }
                        />
                      </Col>
                      <InputGroup.Append>
                        <Button
                          variant="btn btn-green"
                          disabled={!this.state.newMemberValid}
                          onClick={this.handleAddMember}
                          style={{
                            borderBottomLeftRadius: "0px",
                            borderTopLeftRadius: "0px",
                          }}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                    <Table size="sm" className="students-table mt-2">
                      {this.state.validation.auditors.value?.length > 0 && (
                        <thead>
                          <tr>
                            <th>
                              {this.props.t(
                                "Groups.GroupModal.Form.ColumnEmail",
                              )}
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                      )}
                      <tbody>
                        {this.state.validation.auditors.value?.map((m, idx) => (
                          <tr key={idx}>
                            <td>{m.email}</td>
                            <td>
                              <Button
                                className="btn btn-red btn-sm floatRight"
                                onClick={() => this.handleRemoveMember(m)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                  <Accordion.Toggle
                      as={Button}
                      variant="link"
                      className="acc-link"
                      eventKey="1"
                  >
                    <FontAwesomeIcon
                        icon={faExclamationCircle}
                        className={
                          this.state.validation.instanceTemplateId.isValid
                              ? "display-none"
                              : "mr-2 color-red"
                        }
                    />
                    <span>
                      {t(
                          "Examinations.CreateExamModal.Form.ToggleInstanceTemplate",
                      )}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <Form.Group controlId="formSelectInstanceTemplate">
                      <BaseSelect
                          options={this.props.instanceTemplates}
                          onChange={(s) => {
                            this.setState({
                              selectedInstanceTemplate: s,
                              selectedNetworkProfile: this.props.networkProfiles.find(
                                  (n) => n._id === s.preferredNetworkProfile,
                              ),
                            });
                            this.handleChange({
                              target: {
                                name: "instanceTemplateId",
                                value: s._id,
                              },
                            });
                            this.handleChange({
                              target: {
                                name: "networkProfileId",
                                value: s.preferredNetworkProfile,
                              },
                            });
                          }}
                          defaultValue={this.state.selectedInstanceTemplate}
                          value={this.props.instanceTemplates
                              .filter(
                                  (i) =>
                                      i._id ===
                                      this.state.validation.instanceTemplateId.value,
                              )
                              .shift()}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option._id}
                          placeholder={t(
                              "Examinations.CreateExamModal.Form.InstanceTemplatePlaceholder",
                          )}
                      />
                      <Form.Control
                          type="hidden"
                          isInvalid={
                            !this.state.validation.instanceTemplateId.isValid
                          }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                            "Examinations.CreateExamModal.ValidationError.InstanceTemplateId",
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    {this.state.selectedInstanceTemplate ? (
                        <MarkDownViewer
                            text={
                              this.state.selectedInstanceTemplate
                                  ? this.state.selectedInstanceTemplate.description
                                  : null
                            }
                        />
                    ) : (
                        ""
                    )}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="2"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.networkProfileId.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t(
                        "Examinations.CreateExamModal.Form.ToggleNetworkProfile",
                      )}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <Form.Group controlId="formSelectNetworkProfile">
                      {showPreferredNetworkProfileAlert && (
                        <Alert variant="warning">
                          {t(
                            "Examinations.CreateExamModal.Form.PreferredNetworkProfileWarning",
                          )}
                        </Alert>
                      )}
                      <BaseSelect
                        options={this.props.networkProfiles}
                        onChange={(s) => {
                          this.setState({ selectedNetworkProfile: s });
                          this.handleChange({
                            target: {
                              name: "networkProfileId",
                              value: s._id,
                            },
                          });
                        }}
                        defaultValue={
                          this.state.selectedInstanceTemplate
                            ?.preferredNetworkProfile
                        }
                        value={this.props.networkProfiles
                          .filter(
                            (o) =>
                              o._id ===
                              this.state.validation.networkProfileId.value,
                          )
                          .shift()}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option._id}
                        placeholder={t(
                          "Examinations.CreateExamModal.Form.NetworkProfilePlaceholder",
                        )}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={
                          !this.state.validation.networkProfileId.isValid
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "Examinations.CreateExamModal.ValidationError.NetworkProfileId",
                        )}
                      </Form.Control.Feedback>
                      {this.state.selectedNetworkProfile ? (
                        <MarkDownViewer
                          text={
                            this.state.selectedNetworkProfile
                              ? this.state.selectedNetworkProfile.description
                              : null
                          }
                        />
                      ) : (
                        ""
                      )}
                    </Form.Group>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="3"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.instructions.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t("Examinations.CreateExamModal.Form.Instructions")}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <MarkDownEditor
                      defaultValue={instructions}
                      onChange={(value) =>
                        this.handleChange({
                          target: {
                            name: "instructions",
                            value: value,
                          },
                        })
                      }
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(CreateExaminationDialog);
